import { useEffect } from 'react'

import {
  getPatchReceptionCallHistoryByMeetingIdMutationKey,
  usePatchReceptionCallHistoryByMeetingId,
} from '@reception-web/common/api/www'
import {
  HISTORY_CALLER_STATUS,
  HISTORY_RECEIVER_STATUS,
} from '@reception-web/common/consts'
import {
  DeviceLabelTriggerStatus,
  MeetingStatus,
  VideoTileGrid,
  useLocalVideo,
  useMeetingManager,
} from 'amazon-chime-sdk-component-library-react'

import { useDeviceIdProvider, useMeeting, useMeetingContext } from '../../hooks'
import { AgreementModal } from '../contents/AgreementModal'
import { DevicePermissionModal } from '../contents/DevicePermissionModal'

function MeetingComponent() {
  const { meeting, attendee, isRedial } = useMeetingContext()
  const meetingManager = useMeetingManager()
  const { startMeeting, deviceLabelTriggerStatus } = useMeeting()

  const { isVideoEnabled, toggleVideo } = useLocalVideo()
  const { deviceId } = useDeviceIdProvider()
  const { trigger: changeStatus } = usePatchReceptionCallHistoryByMeetingId(
    deviceId ?? '',
    meeting?.MeetingId ?? '',
    {
      swr: {
        swrKey: getPatchReceptionCallHistoryByMeetingIdMutationKey(
          deviceId ?? '',
          meeting?.MeetingId ?? ''
        )[0],
      },
    }
  )

  useEffect(() => {
    if (meetingManager.meetingStatus !== MeetingStatus.Succeeded) {
      startMeeting()
    }

    if (meeting && attendee) {
      if (!isRedial) {
        changeStatus({
          caller_status: HISTORY_CALLER_STATUS.THE_CALL_ESTABLISHED,
          established: new Date().toISOString(),
        })
      } else {
        changeStatus({
          receiver_status: HISTORY_RECEIVER_STATUS.THE_CALL_ESTABLISHED,
          established: new Date().toISOString(),
        })
      }
    }
  }, [meeting, attendee, meetingManager, changeStatus, startMeeting, isRedial])

  if (meeting && !isVideoEnabled) {
    toggleVideo()
  }

  return (
    <div className="h-full w-full shadow-md">
      <div style={{ height: '100%', border: '1px solid #ccc' }}>
        <VideoTileGrid />
      </div>
      {/* Added modal to prompt user action to enable mic. Without user interaction, the mic may not be activated. */}
      {deviceLabelTriggerStatus === DeviceLabelTriggerStatus.DENIED ? (
        <DevicePermissionModal />
      ) : (
        <AgreementModal />
      )}
    </div>
  )
}

export default MeetingComponent
